var _filter, _radialGradient, _radialGradient2, _linearGradient, _clipPath, _clipPath2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg16X9100DollarGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 338,
    viewBox: "0 0 600 338",
    width: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 262.688,
    width: 397.223,
    x: 107.747,
    y: 43.7472
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.12641
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1604_12412"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.32344,
    dy: 8.78812
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.32344
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_1604_12412",
    mode: "normal",
    result: "effect2_dropShadow_1604_12412"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1604_12412",
    mode: "normal",
    result: "shape"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(-603.00081591 368.99842161 -656.96839263 -1073.58854017 559.5 20.5)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25672d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25672d",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(-332.99806887 273.00250646 -435.31651496 -530.98251995 301 -25.5)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 343.5,
    x2: 18.5575,
    y1: 4.50001,
    y2: 219.087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.23
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h600v337.5h-600z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m142 78h32v32h-32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h600v337.5h-600z",
    fill: "#459c4e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 195,
    fill: "#fff",
    fillOpacity: 0.08,
    r: 309.375
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 195,
    fill: "#fff",
    fillOpacity: 0.08,
    r: 265.659
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 195,
    fill: "#fff",
    fillOpacity: 0.08,
    r: 220.262
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h600v337h-600z",
    fill: "url(#b)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#c)",
    height: 229,
    rx: 24,
    transform: "matrix(-1 .00000009 .00000009 1 483 54)",
    width: 365
  }), /*#__PURE__*/React.createElement("rect", {
    height: 228,
    rx: 23.5,
    stroke: "url(#d)",
    transform: "matrix(-1 .00000009 .00000009 1 482 54)",
    width: 364,
    x: -0.5,
    y: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m356.77 264.727c-2.051 0-3.623-.37-4.717-1.108s-1.64-1.773-1.64-3.103c0-.93.291-1.718.875-2.366.583-.638 1.417-1.08 2.502-1.326-.411-.182-.766-.465-1.067-.847-.292-.392-.437-.825-.437-1.299 0-.565.159-1.048.478-1.449.319-.402.798-.789 1.436-1.163-.793-.337-1.431-.884-1.914-1.64-.474-.766-.711-1.664-.711-2.694 0-1.093.232-2.023.697-2.789.465-.774 1.144-1.362 2.037-1.763.893-.41 1.973-.616 3.24-.616.274 0 .57.019.889.055.328.027.629.064.902.11.283.036.497.077.643.123h5.236v1.791l-2.57.478c.246.346.442.743.588 1.19.146.437.219.916.219 1.435 0 1.568-.543 2.803-1.627 3.705-1.076.893-2.562 1.34-4.457 1.34-.456-.018-.898-.055-1.327-.109-.328.2-.578.423-.752.67-.173.237-.259.505-.259.806 0 .246.086.447.259.602.174.146.429.255.766.328.346.073.766.109 1.258.109h2.611c1.659 0 2.926.351 3.801 1.053s1.313 1.732 1.313 3.09c0 1.722-.711 3.049-2.133 3.978-1.422.939-3.468 1.409-6.139 1.409zm.123-2.256c1.121 0 2.065-.11 2.83-.328.766-.219 1.345-.534 1.736-.944.392-.401.588-.879.588-1.435 0-.493-.123-.871-.369-1.135s-.615-.447-1.107-.547-1.103-.15-1.832-.15h-2.379c-.593 0-1.117.091-1.572.273-.456.191-.812.465-1.067.82-.246.356-.369.784-.369 1.286 0 .692.305 1.225.916 1.599.62.374 1.495.561 2.625.561zm.629-11.785c.939 0 1.636-.256 2.092-.766.456-.52.683-1.249.683-2.188 0-1.02-.237-1.786-.711-2.296-.464-.511-1.157-.766-2.078-.766-.902 0-1.59.26-2.064.779-.465.52-.697 1.29-.697 2.311 0 .92.232 1.64.697 2.16.474.51 1.167.766 2.078.766zm13.336-7.821v15.135h-3.213v-15.135zm-1.586-5.797c.492 0 .916.133 1.271.397.365.264.547.72.547 1.367 0 .638-.182 1.094-.547 1.367-.355.265-.779.397-1.271.397-.51 0-.943-.132-1.299-.397-.346-.273-.519-.729-.519-1.367 0-.647.173-1.103.519-1.367.356-.264.789-.397 1.299-.397zm13.418 8.244h-3.678v12.688h-3.213v-12.688h-2.474v-1.544l2.474-.944v-1.053c0-1.285.201-2.306.602-3.062.41-.757.993-1.299 1.75-1.627.765-.337 1.677-.506 2.734-.506.693 0 1.326.059 1.901.178.574.109 1.057.237 1.449.383l-.834 2.433c-.31-.1-.656-.191-1.039-.273-.383-.091-.793-.137-1.231-.137-.729 0-1.267.228-1.613.684-.337.455-.506 1.121-.506 1.996v1.025h3.678zm7.881 10.364c.419 0 .834-.037 1.244-.11.41-.082.784-.177 1.121-.287v2.434c-.356.155-.816.287-1.381.396-.565.11-1.153.164-1.764.164-.856 0-1.627-.141-2.31-.423-.684-.292-1.226-.789-1.627-1.491-.401-.701-.602-1.672-.602-2.912v-8.135h-2.064v-1.435l2.215-1.135 1.052-3.24h2.024v3.363h4.334v2.447h-4.334v8.094c0 .766.191 1.336.574 1.709.383.374.889.561 1.518.561zm18.14 2.597c-1.431 0-2.67-.278-3.719-.834-1.048-.556-1.854-1.408-2.42-2.556-.565-1.149-.847-2.607-.847-4.375 0-1.841.31-3.345.929-4.512.62-1.167 1.477-2.028 2.571-2.584 1.103-.556 2.365-.834 3.787-.834.902 0 1.718.091 2.447.274.738.173 1.363.387 1.873.642l-.957 2.57c-.556-.227-1.125-.419-1.709-.574-.583-.155-1.144-.232-1.681-.232-.885 0-1.623.196-2.215.588-.584.392-1.021.975-1.313 1.75-.282.774-.424 1.736-.424 2.884 0 1.112.146 2.051.438 2.817.292.756.725 1.331 1.299 1.723.574.382 1.28.574 2.119.574.829 0 1.572-.101 2.228-.301.657-.201 1.276-.46 1.86-.779v2.789c-.574.328-1.19.569-1.846.724-.656.164-1.463.246-2.42.246zm13.418-15.695c1.914 0 3.359.424 4.334 1.272.984.847 1.477 2.169 1.477 3.964v10.186h-2.284l-.615-2.146h-.109c-.429.546-.871.998-1.326 1.353-.456.355-.985.62-1.586.793-.593.182-1.317.273-2.174.273-.903 0-1.709-.164-2.42-.492-.711-.337-1.272-.847-1.682-1.531s-.615-1.549-.615-2.598c0-1.558.579-2.729 1.736-3.513 1.167-.784 2.926-1.217 5.278-1.299l2.625-.096v-.793c0-1.048-.246-1.795-.739-2.242-.483-.447-1.166-.67-2.05-.67-.757 0-1.491.109-2.202.328-.71.219-1.403.488-2.078.807l-1.039-2.27c.739-.392 1.577-.711 2.516-.957.948-.246 1.932-.369 2.953-.369zm2.625 8.19-1.955.068c-1.604.055-2.73.328-3.377.82s-.971 1.167-.971 2.024c0 .747.224 1.294.67 1.64.447.338 1.035.506 1.764.506 1.112 0 2.032-.314 2.762-.943.738-.638 1.107-1.572 1.107-2.803zm15.018-8.19c.255 0 .533.014.834.041.3.027.56.064.779.11l-.301 3.007c-.191-.054-.428-.095-.711-.123-.273-.027-.519-.041-.738-.041-.574 0-1.121.096-1.641.287-.519.183-.98.465-1.381.848-.401.374-.715.843-.943 1.408s-.342 1.222-.342 1.969v7.916h-3.226v-15.135h2.515l.438 2.666h.15c.301-.538.675-1.03 1.121-1.476.447-.447.957-.802 1.531-1.067.584-.273 1.222-.41 1.915-.41zm9.166 15.695c-1.805 0-3.254-.656-4.348-1.968-1.085-1.322-1.627-3.268-1.627-5.838 0-2.598.551-4.562 1.654-5.893 1.112-1.331 2.575-1.996 4.389-1.996.765 0 1.435.105 2.01.315.574.2 1.066.474 1.476.82.419.346.775.734 1.067 1.162h.15c-.046-.283-.1-.688-.164-1.217-.055-.538-.082-1.034-.082-1.49v-5.441h3.226v21.273h-2.515l-.574-2.064h-.137c-.274.437-.62.834-1.039 1.189-.41.346-.903.624-1.477.834-.565.21-1.235.314-2.009.314zm.902-2.611c1.376 0 2.347-.396 2.912-1.189s.857-1.983.875-3.569v-.424c0-1.695-.273-2.994-.82-3.896-.547-.911-1.545-1.367-2.995-1.367-1.157 0-2.041.469-2.652 1.408-.601.93-.902 2.229-.902 3.896 0 1.668.301 2.944.902 3.829.611.875 1.504 1.312 2.68 1.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.281 261v-5.397c-1.519-.034-2.985-.221-4.4-.562-1.397-.341-2.648-.776-3.752-1.305v-5.013c1.087.665 2.355 1.254 3.804 1.765 1.449.512 2.898.784 4.348.819v-10.563c-1.898-.751-3.459-1.561-4.684-2.43-1.225-.887-2.131-1.91-2.717-3.069-.587-1.16-.88-2.541-.88-4.144 0-1.705.345-3.18 1.035-4.424.707-1.262 1.682-2.268 2.924-3.018 1.259-.767 2.7-1.236 4.322-1.407v-4.066h2.898v3.989c1.328.069 2.613.273 3.855.614 1.26.324 2.467.785 3.623 1.381l-1.371 4.195c-.949-.512-1.933-.904-2.95-1.177-1.001-.29-2.053-.477-3.157-.562v10.384c1.863.733 3.398 1.517 4.606 2.353 1.225.818 2.13 1.781 2.717 2.89.604 1.091.905 2.421.905 3.989 0 2.388-.715 4.408-2.147 6.062-1.432 1.637-3.459 2.677-6.081 3.12v5.576zm2.898-9.975c1.242-.29 2.173-.827 2.794-1.611.621-.801.932-1.739.932-2.813 0-.751-.138-1.399-.414-1.944-.259-.546-.664-1.032-1.216-1.458-.535-.443-1.234-.861-2.096-1.253zm-2.898-15.243v-9.105c-.811.136-1.493.409-2.045.818-.535.392-.94.895-1.216 1.509s-.414 1.322-.414 2.123c0 .767.121 1.424.362 1.969.259.529.656 1.006 1.191 1.433.534.409 1.242.827 2.122 1.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.087 257.956v-23.709c0-.767.009-1.534.026-2.302.018-.767.043-1.534.078-2.301.034-.785.069-1.552.103-2.302-.224.307-.517.673-.879 1.1-.345.409-.785.878-1.32 1.406l-3.286 3.223-3.261-3.325 9.238-9.182h4.917v37.392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.055 239.26c0 2.899-.173 5.525-.518 7.878-.328 2.353-.871 4.373-1.63 6.061-.742 1.688-1.734 2.993-2.976 3.913-1.242.904-2.769 1.356-4.58 1.356-1.587 0-2.985-.35-4.192-1.049-1.208-.699-2.226-1.799-3.054-3.299-.81-1.518-1.431-3.496-1.863-5.934-.414-2.455-.621-5.43-.621-8.926 0-4.348.354-7.945 1.061-10.793.707-2.847 1.786-4.962 3.235-6.343 1.449-1.398 3.26-2.097 5.434-2.097 2.191 0 4.002.716 5.434 2.148 1.432 1.433 2.501 3.581 3.209 6.446.707 2.847 1.061 6.394 1.061 10.639zm-13.793 0c0 4.808.302 8.389.906 10.742.621 2.336 1.682 3.504 3.183 3.504 1.466 0 2.51-1.168 3.131-3.504.621-2.353.931-5.942.931-10.767 0-3.155-.138-5.789-.414-7.903-.258-2.115-.69-3.7-1.293-4.758-.587-1.057-1.372-1.585-2.355-1.585-1.001 0-1.803.528-2.407 1.585-.586 1.041-1.018 2.618-1.294 4.732-.258 2.114-.388 4.766-.388 7.954z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223 239.26c0 2.899-.173 5.525-.518 7.878-.327 2.353-.871 4.373-1.63 6.061-.742 1.688-1.733 2.993-2.976 3.913-1.242.904-2.768 1.356-4.58 1.356-1.587 0-2.984-.35-4.192-1.049-1.207-.699-2.225-1.799-3.053-3.299-.811-1.518-1.432-3.496-1.863-5.934-.414-2.455-.621-5.43-.621-8.926 0-4.348.353-7.945 1.061-10.793.707-2.847 1.785-4.962 3.234-6.343 1.449-1.398 3.261-2.097 5.434-2.097 2.191 0 4.003.716 5.434 2.148 1.432 1.433 2.502 3.581 3.209 6.446.707 2.847 1.061 6.394 1.061 10.639zm-13.792 0c0 4.808.302 8.389.905 10.742.621 2.336 1.682 3.504 3.183 3.504 1.467 0 2.51-1.168 3.131-3.504.621-2.353.932-5.942.932-10.767 0-3.155-.138-5.789-.414-7.903-.259-2.115-.69-3.7-1.294-4.758-.586-1.057-1.371-1.585-2.355-1.585-1 0-1.802.528-2.406 1.585-.587 1.041-1.018 2.618-1.294 4.732-.259 2.114-.388 4.766-.388 7.954z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m174 96.4259-5.995-5.8157v-8.7373h-4.01v4.851l-5.995-5.8157-16 15.5177v.9646h3.997v9.7025h10.005v-5.816h3.996v5.816h10.005v-9.7025h3.997z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16X9100DollarGiftCard);
export default __webpack_public_path__ + "static/media/16x9-100-dollar-gift-card.d26f1e97984ddedf85efab044fcfc6e0.svg";
export { ForwardRef as ReactComponent };